module.exports = __webpack_public_path__ + "img/22.60692c64.png";